import React, { Component } from 'react';
import { Col, Row, Card, CardBody, Container, Button, Table } from 'reactstrap';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { Field, reduxForm } from 'redux-form';
import DataReactTable from '../../ClinicHistory/ClinicHistoryView/components/Diagnostic/DataReactTable';
import MomentUtils from '@date-io/moment';
import Modal from '@material-ui/core/Modal';
import ReactTableActionsDiagnostic from '../../ClinicHistory/ClinicHistoryView/components/Diagnostic/ReactTableActionsDiagnostic';
import { withTranslation } from 'react-i18next';
import history from '../../../history';

class EventAdverseForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            load: false,
            isLoading: false,
            openModal: false,
            dataDiagnostic: [],
            diagnostic: [],
            studiesList: [],
            thirdList: [],
            countries: [],
            mfr_control: '',
            fecha_recepcion: null,
            fecha_reporte: null,
            tipo_reporte: '',
            id_pais: '',
            id_estudio: 0,
            clasificacion_evento: '',
            cod_sujeto: '',
            file: null,            
        }
    }

    componentDidMount() {
        this.loadDataStudies();
        this.loadDataThirds();
        this.loadCountries();

    }

   loadDataStudies = () => {

        fetch(process.env.REACT_APP_PUBLIC_URL + 'estudiosc/listar', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                if (data.existe) {
                    this.setState({ studiesList: data.contenido });
                }
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    loadDataThirds = () => {

        fetch(process.env.REACT_APP_PUBLIC_URL + 'tercero/listar-patrocinadores', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                this.setState({ thirdList: data });
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    loadCountries = () => {

        fetch(process.env.REACT_APP_PUBLIC_URL + 'paises/listar', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                this.setState({ countries: data });
            })
            .catch((error) => {
                console.error('Error:', error);
            });

    }

    searchCIE = (name, code) => {

        var data = {
            codigo: code,
            nombre: name
        };

        return new Promise((resolve, reject) => {
            fetch(process.env.REACT_APP_PUBLIC_URL + 'cie10/consultar', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(data)
            })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    console.log(data);
                    if (data.existe) {
                        resolve(data.contenido);
                    } else {
                        resolve([]);
                    }
                })
                .catch((error) => {
                    console.error('Error:', error);
                    resolve(error);
                });
        })
    };

    saveEventAdverse = () =>{

        let diagnosticos = {diagnosticos: this.state.diagnostic};

        //console.log(diagnosticos);
    
        let dataFile = new FormData();
        dataFile.append("archivo", this.state.file);
        dataFile.append("id_estudio", parseInt(this.state.id_estudio));
        dataFile.append("id_tercero", parseInt(this.state.id_tercero));
        dataFile.append("mfr_control_no", this.state.mfr_control);
        dataFile.append("fecha_recepcion", this.state.fecha_recepcion);
        dataFile.append("fecha_reporte", this.state.fecha_reporte);
        dataFile.append("tipo_reporte", parseInt(this.state.tipo_reporte));
        dataFile.append("id_pais", this.state.id_pais);
        dataFile.append("clasificacion_evento", parseInt(this.state.clasificacion_evento));
        dataFile.append("cod_sujeto", this.state.cod_sujeto);
        dataFile.append("diagnostico", diagnosticos);
               

        fetch(process.env.REACT_APP_PUBLIC_URL + 'evento-adverso-estudio/create', {
            method: 'POST',
            headers: {
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: dataFile
        })
            .then(response => {
                return response.text();
            })
            .then(data => {
                console.log(data);
                alert("archivo creado correctamente");
                history.push({
                    pathname: process.env.PUBLIC_URL +'/assitencial/eventadverse'
                });
            });
    }

    render() {

        const reactTableFoundDiagnostics = {
            tableHeaderData: [{
                Header: 'Codigo',
                accessor: 'codigo',
                disableGlobalFilter: true,
                width: 65,
            },
            {
                Header: 'Nombre',
                accessor: 'nombre',
            },
            ],
            tableRowsData: this.state.dataDiagnostic
        };

        return (
            <Container >
                <Row>
                    <Col md={12}>
                        <h3 className="page-title">Análisis de CIOM y SUSAR</h3>
                    </Col>
                </Row>
                <Card >
                    <CardBody style={{ display: 'flex', justifyContent: 'center' }}>
                        <Col md={7}>
                            <div >
                                <form className="material-form" >

                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                        <TextField
                                            className="material-form__field"
                                            label="Estudio Clinico"
                                            id="studio-select"
                                            style={{ width: 300, margin: 15 }}
                                            select
                                            defaultValue={null}
                                            onChange={(event) => {                                                
                                                this.setState({ id_estudio: event.target.value })
                                            }}
                                        >
                                            {this.state.studiesList.map((study) => {
                                                return <MenuItem className="material-form__option" key={study.id_estudio} value={study.id_estudio}>{study.nombre}</MenuItem>
                                            })}
                                        </TextField>
                                    </div>

                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                        <TextField
                                            className="material-form__field"
                                            style={{ width: 300, margin: 15 }}
                                            id="id-patrocinador"
                                            label="Patrocinador"
                                            select
                                            defaultValue={null}
                                            onChange={(e) => {                                        
                                                this.setState({ id_tercero: e.target.value })
                                            }}
                                        >
                                            {this.state.thirdList.map((third) => {
                                                return <MenuItem className="material-form__option" key={third.id_tercero} value={third.id_tercero}>{third.nombre}</MenuItem>
                                            })}
                                        </TextField>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'center' }}>

                                        <TextField
                                            required
                                            className="material-form__field"
                                            style={{ width: 300, margin: 15 }}
                                            id="id-mfr"
                                            label="MFR Control No."
                                            type="text"
                                            onChange={(e) => {
                                                this.setState({ mfr_control: e.target.value});
                                            }}
                                        />
                                    </div>

                                    <div style={{ display: 'flex', justifyContent: 'center' }}>

                                        <MuiPickersUtilsProvider utils={MomentUtils} >
                                            <DatePicker
                                                label="Fecha de Recepcion"
                                                className="material-form__field"
                                                onChange={(date) => {
                                                    this.setState({ fecha_recepcion: date });
                                                }}
                                                format="yyyy/MM/DD"
                                                animateYearScrolling
                                                style={{ width: 300, margin: 15 }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}

                                            />
                                        </MuiPickersUtilsProvider>
                                    </div>

                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                        <MuiPickersUtilsProvider utils={MomentUtils} >
                                            <DatePicker
                                                label="Fecha de Reporte"
                                                className="material-form__field"
                                                onChange={(date) => {
                                                    this.setState({ fecha_reporte: date });
                                                }}
                                                format="yyyy/MM/DD"
                                                animateYearScrolling
                                                style={{ width: 300, margin: 15 }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}

                                            />
                                        </MuiPickersUtilsProvider>
                                    </div>

                                    <div style={{ display: 'flex', justifyContent: 'center', margin: 30 }}>
                                        <div>
                                            <div >
                                                <h4>Tipo de Reporte </h4>
                                            </div>
                                            <div className="form__form-group-field" style={{ marginLeft: 15, }}>
                                                <label
                                                    className="radio-btn"
                                                >
                                                    <input
                                                        className="radio-btn__radio"
                                                        name="type"
                                                        type="radio"
                                                        value={'1'}
                                                        onChange={(e) => {                                                            
                                                            this.setState({ tipo_reporte: e.target.value});

                                                        }}
                                                    />
                                                    <span className="radio-btn__radio-custom" />
                                                    <span className="radio-btn__label">{"Inicial"}</span>
                                                </label>
                                                <label
                                                    className="radio-btn"
                                                >
                                                    <input
                                                        className="radio-btn__radio"
                                                        name="type"
                                                        type="radio"
                                                        value={'2'}
                                                        onChange={(e) => {
                                                            this.setState({ tipo_reporte: e.target.value});

                                                        }}
                                                    />
                                                    <span className="radio-btn__radio-custom" />
                                                    <span className="radio-btn__label">{"Seguimiento"}</span>
                                                </label>
                                                <label
                                                    className="radio-btn"
                                                >
                                                    <input
                                                        className="radio-btn__radio"
                                                        name="type"
                                                        type="radio"
                                                        value={'3'}
                                                        onChange={(e) => {
                                                            this.setState({ tipo_reporte: e.target.value});
                                                        }}
                                                    />
                                                    <span className="radio-btn__radio-custom" />
                                                    <span className="radio-btn__label">{"Final"}</span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                        <TextField
                                            className="material-form__field"
                                            label="País"
                                            id="pais-select"
                                            style={{ width: 300, margin: 15 }}
                                            select
                                            onChange={(event) => {                                                
                                                this.setState({ id_pais: event.target.value});
                                            }}
                                        >
                                            {this.state.countries.map((country) => {
                                                return <MenuItem className="material-form__option" key={country.paicod} value={country.paicod}>{country.painom}</MenuItem>
                                            })}
                                        </TextField>
                                    </div>

                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                        <TextField
                                            className="material-form__field"
                                            label="Clasificación Evento"
                                            id="clasificacion-select"
                                            style={{ width: 300, margin: 15 }}
                                            select
                                            onChange={(event) => {                                                
                                                this.setState({ clasificacion_evento: event.target.value});
                                            }}
                                        >
                                            <MenuItem className="material-form__option" key={1} value={'1'}>CIOMS</MenuItem>
                                        </TextField>
                                    </div>

                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                        <TextField
                                            required
                                            className="material-form__field"
                                            style={{ width: 300, margin: 15 }}
                                            id="id-sujeto"
                                            label="Id Sujeto"
                                            type="text"
                                            onChange={(e) => {
                                                this.setState({ cod_sujeto: e.target.value});
                                            }}
                                        />
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'center', backgroundColor: 'lightgray' }}>

                                        <h4 >Archivo Adjunto </h4>
                                    </div>

                                    <div style={{ display: 'flex', justifyContent: 'center', marginTop: 20 }}>

                                        <input
                                            type="file"
                                            onChange={(e) => {                                                
                                                this.setState({ file: e.target.files[0]})
                                            }}
                                        />
                                    </div>

                                    <div style={{ display: 'flex', marginTop: 50, justifyContent: 'center' }}>
                                        <div style={{ marginRight: 20 }} >
                                            <span className="form__form-group-label">Diagnostico del CIOM o SUSAR</span>
                                        </div>
                                        <Button
                                            outline
                                            onClick={() => {

                                                this.setState({ openModal: true });
                                            }}
                                        >
                                            <span className="lnr lnr-magnifier" style={{ fontSize: 20 }} />
                                        </Button>
                                        <TextField
                                            type="text"
                                            className="material-form__field"
                                            disabled
                                            style={{ width: 120, marginRight: 20 }}
                                            value={typeof this.state.diagnostic.codigo !== 'undefined' ? this.state.diagnostic.codigo : ""}
                                        />
                                        <TextField
                                            type="text"
                                            className="material-form__field"
                                            disabled
                                            style={{ width: '70%' }}
                                            value={typeof this.state.diagnostic.nombre !== 'undefined' ? this.state.diagnostic.nombre : ""}
                                        />
                                    </div>
                                </form>
                                <Table bordered style={{ marginTop: 20, marginLeft: 50 }}>
                                    <thead>
                                        <tr>
                                            <td>Codigo </td>
                                            <td >Descripcion </td>
                                            <td >Opciones </td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.diagnostic.map((data, index) => {
                                            return <tr key={index}>
                                                <td>{data.codigo}</td>
                                                <td>{data.nombre}</td>
                                            </tr>
                                        })}
                                    </tbody>

                                </Table>

                                <Button
                                style={{ margin: 20 }}
                                onClick={() => {
                                    this.saveEventAdverse();
                                }}>
                                   
                                Guardar
                                   </Button> 
                                <Modal
                                    open={this.state.openModal}
                                    onClose={() => {
                                        this.setState({ openModal: false });
                                    }}
                                    aria-labelledby="simple-modal-title"
                                    aria-describedby="simple-modal-description"
                                    style={{ zIndex: 1000 }}
                                >
                                    <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>
                                        <div>
                                            <h5 className="bold-text">Diagnostico</h5>
                                        </div>
                                        <div className="form">
                                            <div style={{ display: 'flex', width: '100%' }}>
                                                <div className="form__form-group" style={{ marginRight: 10 }}>
                                                    <span className="form__form-group-label">CIE 10</span>
                                                    <div className="form__form-group-field">
                                                        <Field
                                                            name="search-cups"
                                                            component="input"
                                                            type="text"
                                                            placeholder="Codigo"
                                                            //value={this.props.MedicalOrders.cups.cupsnom}
                                                            onChange={(e) => {
                                                                //this.props.handlerCUPS(e.target.value);
                                                                console.log(e.target.value);
                                                                this.setState({ load: true }, () => {
                                                                    this.searchCIE("", e.target.value).then((dataDiagnostic) => {
                                                                        //console.log(dataDiagnostic);
                                                                        this.setState({ dataDiagnostic: dataDiagnostic, load: false });
                                                                        //console.log(this.state.dataDiagnostic);
                                                                    });
                                                                });
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="form__form-group">
                                                    <span className="form__form-group-label">Nombre</span>
                                                    <div className="form__form-group-field">
                                                        <input
                                                            name="search-diagnostic"
                                                            type="text"
                                                            placeholder="Diagnostico"
                                                            //value={this.props.Diagnostic.name}
                                                            onChange={(e) => {
                                                                //this.props.handlerDiagnosticName(e.target.value);
                                                                var diagnostic = e.target.value;
                                                                this.setState({ load: true }, () => {
                                                                    console.log(diagnostic)
                                                                    this.searchCIE(diagnostic, "").then((dataDiagnostic) => {
                                                                        //console.log(dataDiagnostic);
                                                                        this.setState({ dataDiagnostic: dataDiagnostic, load: false });
                                                                        ///console.log(this.state.dataDiagnostic);
                                                                    });
                                                                });
                                                            }}
                                                        >
                                                        </input>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                                            {!this.state.load ?
                                                <DataReactTable
                                                    title=""
                                                    reactTableData={reactTableFoundDiagnostics}
                                                    config={{
                                                        withPagination: true,
                                                        withSearchEngine: false,
                                                        isSortable: false,
                                                        watchCustomMenu: false
                                                    }}
                                                    ReactTableActions={ReactTableActionsDiagnostic}
                                                    Callback={(diagnostic) => {
                                                        this.state.diagnostic.push(diagnostic)
                                                        this.setState({ openModal: false,});
                                                    }}
                                                /> : <div style={{ margin: 'auto', width: 270, height: 420 }}>
                                                    <div class="load__icon-wrap">
                                                        <svg class="load__icon">
                                                            <path fill="#4ce1b6" d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z" />
                                                        </svg>
                                                    </div>
                                                </div>}
                                        </div>
                                    </div>
                                </Modal>
                            </div>
                        </Col>
                    </CardBody>
                </Card>
            </Container>
        );

    }
}

export default reduxForm({
    form: `add-event-adverse-form`, // a unique identifier for this form
})(withTranslation('common')(EventAdverseForm));
